import React from "react";

import {
  ImageOutlined,
  PictureAsPdfOutlined,
  VideocamOutlined,
} from "@mui/icons-material";

/**
 * An attached file reads as a chip; the icon says which kind it is without opening anything.
 *
 * The pdf branch comes before the image fallback because `application/pdf` matches neither of the
 * other two, and falling through left every pdf wearing a picture icon.
 */
export const mediaChipIcon = (contentType: string): React.ReactElement => {
  if (contentType.includes("video"))
    return <VideocamOutlined fontSize="small" />;
  if (contentType.includes("pdf"))
    return <PictureAsPdfOutlined fontSize="small" />;
  return <ImageOutlined fontSize="small" />;
};
